import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { FAInnerWrapperColumn } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/components/styles";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { trackOpenWithFaireFaireAcademySectionView } from "@faire/web-api--source/events/openWithFaire/view/faireAcademySection";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { SlideIn } from "@faire/web/ui/SlideIn/SlideIn";
import React from "react";

export const MissionStatement: React.FC = () => {
  const { pageState } = useGetFaireAcademyPageState();
  const ref = useDoActionWhenVisible(() =>
    trackOpenWithFaireFaireAcademySectionView(
      pageState,
      OWF_SECTION_NAME.MISSION_STATEMENT
    )
  );

  if (isLoggedInRetailer()) {
    return null;
  }

  return (
    <FAInnerWrapperColumn ref={ref}>
      <SlideIn offset="50px">
        <Typography
          align="left"
          variant={{
            mobileAndAbove: "paragraphSansMedium",
            desktopAndAbove: "sectionHeaderSansMedium",
          }}
        >
          <StrictLocalMsg
            id="h6vlsd"
            defaultMessage="The mission"
            description={{
              text: "Mission statement header for Open with Faire landing page",
              img: "https://cdn.faire.com/fastly/5d936610ede2c8cf721884ea7111918cfce4e54f321d716db82a06c2759d84e8.png",
            }}
          />
        </Typography>
      </SlideIn>
      <SlideIn offset="70px">
        <Spacer height={{ mobileAndAbove: "2x", desktopAndAbove: "3x" }} />
        <Typography
          align="left"
          variant={{
            mobileAndAbove: "pageHeaderSerifRegular",
            desktopAndAbove: "displayMSerifRegular",
          }}
        >
          <StrictLocalMsg
            id="M8PVOS"
            defaultMessage="Starting a retail business can be hard. That’s why we created Open with Faire—to help new retailers navigate challenges along the road to opening their dream store."
            description={{
              text: "Mission statement for Open with Faire landing page",
              img: "https://cdn.faire.com/fastly/5d936610ede2c8cf721884ea7111918cfce4e54f321d716db82a06c2759d84e8.png",
            }}
          />
        </Typography>
      </SlideIn>
    </FAInnerWrapperColumn>
  );
};
